import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../services/firebase"; // adjust to your firebase init export

const functions = getFunctions(app, "europe-west1");

export async function ensureUserDoc(): Promise<void> {
  const fn = httpsCallable(functions, "ensureUserDoc");
  await fn({});
}

export async function setActiveContext(clubId: string, seasonId: string, teamId: string) {
  const fn = httpsCallable(functions, "setActiveContext");
  const res = await fn({ clubId, seasonId, teamId });
  return res.data as { ok: boolean; activeSeasonId: string; activeTeamId: string };
}

export async function setAvailability(
  clubId: string,
  seasonId: string,
  teamId: string,
  fixtureId: string,
  status: "yes" | "no" | "unknown"
) {
  const fn = httpsCallable(functions, "setAvailability");
  const res = await fn({ clubId, seasonId, teamId, fixtureId, status });
  return res.data as { ok: boolean; status: "yes" | "no" | "unknown" };
}